export class RealTimeCommunicationError extends Error {
  constructor(message: string) {
    super(message);

    Object.setPrototypeOf(this, RealTimeCommunicationError.prototype);

    this.name = 'RealTimeCommunicationError';
  }
}
